<div dx-resizable="{ handles: 'all', minWidth: 100, maxWidth: 700 }">

  <dx-scroll-view data-testid="service-request-dynamic-scroll-view">

    <form #formElement (submit)="onSubmit($event)">

      <dx-form
        data-testid="service-request-dynamic-form"
        id="form"
        class="cards-wide"
        [formData]="requestData"
        [items]="dynamicFormItems()"
        [showValidationSummary]="true"
        [colCount]="dynamicFormConfig()?.form.colCount ?? 2"
        (onInitialized)="onFormInitialized($event)"
        validationGroup="formGroup">

        <!-- Loan amount grid widget template -->
        <div *dxTemplate="let data of 'loanAmountGridTemplate'">
          <app-loan-amount-grid
            data-testid="service-request-dynamic-loan-amount-grid"
            [config]="getLoanAmountGridConfig(resolveTemplateFieldKey(data))"
            [dataSources]="dynamicFormConfig()?.dataSources"
            [loanDataSource]="loanData"
            [formContext]="requestData"
            [refreshToken]="requestData.__loanLookupVersion ?? 0"
            [showInactiveLoans]="showInactiveLoans"
            [value]="getLoanAmountRows(data)"
            (valueChange)="onLoanAmountValueChange(resolveTemplateFieldKey(data), $event)">
          </app-loan-amount-grid>
        </div>

        <!-- File upload widget template -->
        <div *dxTemplate="let data of 'fileUploadTemplate'">
          <app-file-upload
            data-testid="service-request-dynamic-file-upload"
            labelText=""
            [selectButtonText]="getFileUploadConfig(data.name)?.selectButtonText ?? 'Browse or drop files here'"
            [accept]="getFileUploadConfig(data.name)?.accept ?? '*'"
            [multiple]="getFileUploadConfig(data.name)?.multiple ?? true"
            [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
            (onFileUploadEventEmitter)="onFileUpload($event)"
            (onFileRemoveEventEmitter)="onFileRemove($event)">
          </app-file-upload>
        </div>

        <!-- Display-only label/value widget template -->
        <div *dxTemplate="let data of 'displayLabelTemplate'">
          <div class="display-request-value" data-testid="service-request-dynamic-display-label">
            <span class="display-request-value__label">{{ getDisplayLabelConfig(data.name)?.label ?? '' }}:</span>
            <span class="display-request-value__value">{{ requestData[data.name] ?? '' }}</span>
          </div>
        </div>

        <!-- Combined currency + amount widget template -->
        <div *dxTemplate="let data of 'currencyAmountTemplate'">
          <app-currency-amount-input
            data-testid="service-request-dynamic-currency-amount"
            [config]="getCurrencyAmountConfig(resolveTemplateFieldKey(data))"
            [amount]="getCurrencyAmountValue(data).amount"
            [currency]="getCurrencyAmountValue(data).currency"
            [isEditable]="!isEditable"
            (valueChange)="onCurrencyAmountValueChange(resolveTemplateFieldKey(data), $event)">
          </app-currency-amount-input>
        </div>

      </dx-form>

      <dx-load-panel
        data-testid="service-request-dynamic-load-panel"
        container=".cards-wide"
        [position]="{ of: '.content' }"
        [visible]="isLoading"
        [showPane]="true">
      </dx-load-panel>

    </form>

  </dx-scroll-view>

</div>
